import type { Episode, Podcast } from '@/types';
import { EpisodeCard } from './EpisodeCard';

interface EpisodeListProps {
  episodes: Episode[];
  podcast: Podcast;
  isLoading?: boolean;
}

export function EpisodeList({
  episodes,
  podcast,
  isLoading = false,
}: EpisodeListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="glass-panel animate-pulse">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-full bg-white/5" />
              <div className="flex-1">
                <div className="h-4 bg-white/5 rounded mb-2 w-3/4" />
                <div className="h-3 bg-white/5 rounded w-1/4" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (episodes.length === 0) {
    return (
      <div className="text-center py-8 text-white/60">
        <p>No episodes available</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {episodes.map((episode) => (
        <EpisodeCard key={episode.id} episode={episode} podcast={podcast} />
      ))}
    </div>
  );
}
